// extracted by mini-css-extract-plugin
export default {"addButton":"AddButton_addButton__PBIpC"};